import { useCallback, useEffect, useState } from 'react';
import { Storage } from '@/common/utils';

const useLocalStorageState = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    const storedValue = Storage.get(key);
    return storedValue === undefined ? initialValue : storedValue;
  });

  useEffect(() => {
    const storedValue = Storage.get(key);
    setValue(storedValue === undefined ? initialValue : storedValue);
  }, [initialValue, key]);

  const setStoredValue = useCallback(
    (nextValue) => {
      setValue((currentValue) => {
        const resolvedValue =
          typeof nextValue === 'function' ? nextValue(currentValue) : nextValue;

        Storage.set(key, resolvedValue);
        return resolvedValue;
      });
    },
    [key]
  );

  return [value, setStoredValue];
};

export default useLocalStorageState;
